import axios from "../auth/FetchInterceptor";

export const getReservationsByAnnouncement = async (announcementId, page = 1, limit = 10) => {
  const response = await axios.get(`/announcements/${announcementId}/reservations`, {
    params: { page, limit },
  });
  return response.data;
};
